import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { MdDelete, MdUpload ,MdArrowBack} from "react-icons/md";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_ROUTES, REACT_APP_API_URL } from "../../config/api-config";
import "../add-student-details/AddStudents.css";
import { useLocation, useHistory, useParams } from "react-router-dom";
import "../add-student-details/StudentRegistration.css";
import AutoFaceIdCamera from "../add-student-details/AutoFaceIdCamera";
import "../add-student-details/LogoLoader.css";
import "../add-student-details/LogoLoaders.css";
import { get_all_registered_students } from "services/api-service";

const AddStudentDetailsE = () => {
  const location = useLocation();
  const students_id = location.state || {};

  const [student_id, setStudentId] = useState(students_id.student_id || "");
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [email, setEmailId] = useState("");
  const [mobile_no, setMobileNumber] = useState("");
  const [gender, setGender] = useState("");
  
  const [buyingBehaviour, setBuyingBehaviour] = useState("");
  const [pricing, setPricing] = useState("");
  const [currency, setCurrency] = useState("");

  const [hasServerImage, setHasServerImage] = useState(false); // ✅ Replaced base64 'images' state
  const [multeImage, setMulteImage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [parent_code, setParentCode] = useState("");
  
  const token = localStorage.getItem("accessToken");
  const history = useHistory();
  const { student_id: editId } = useParams();

  const [hidePreview, setHidePreview] = useState(false);
  const [allImages, setAllImages] = useState([]);

  const buyingBehaviours = [
    { value: "Impulse", label: "Impulse Buyer" },
    { value: "Discount", label: "Discount Seeker" },
    { value: "Loyal", label: "Loyal Customer" },
    { value: "Needs-Based", label: "Needs-Based Shopper" },
    { value: "Wandering", label: "Wandering Customer" },
  ];

  const pricingTiers = [
    { value: "0-10k", label: "0 - 10k" },
    { value: "10-20k", label: "10 - 20k" },
    { value: "20-30k", label: "20 - 30k" },
    { value: "30-40k", label: "30 - 40k" },
    { value: "40-50k+", label: "40 - 50k+" },
  ];

  const currencies = [
    { value: "INR", label: "INR (₹)" },
    { value: "USD", label: "USD ($)" },
    { value: "EUR", label: "EUR (€)" },
    { value: "GBP", label: "GBP (£)" },
  ];

  const handleMultipleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setAllImages((prev) => [...prev, ...files]);
    setMulteImage((prev) => [...prev, ...files]);
    if (!hidePreview) setHidePreview(true);
  };

  const handleImageCapture = (files) => {
    setAllImages((prev) => [...prev, files]);
    if (!hidePreview) setHidePreview(true);
  };

  const removeImage = (indexToRemove) => {
    setAllImages((prev) => prev.filter((_, i) => i !== indexToRemove));
    setMulteImage((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const handleSubmit = async () => {
    const imagesh = await Promise.all(
      allImages.map((img) => (img instanceof File ? readFileAsBase64(img) : img))
    );

    toast.warn("Updating customer, please wait...");
    setLoading(true);

    const response = await fetch(
      `${REACT_APP_API_URL}/${API_ROUTES.update_student.replace(/^\//, '')}/${student_id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          student_id,
          first_name,
          last_name,
          email,
          mobile_no,
          selectType: gender,
          buying_behaviour: buyingBehaviour,
          pricing: pricing,                  
          currency: currency,                
          password,
          images: imagesh.length > 0 ? imagesh : null,
        }),
      }
    )
      .then(async (res) => {
        const data = await res.json().catch(() => null);
        if (res?.status === 200) {
          toast.success("Customer Updated Successfully");
          history.push("/admin/FaceDetails", { student_id });
        } else {
          toast.error(data && data.detail);
        }
      })
      .catch((error) => {
        console.log("error", error);
        toast.error(error.message || "An error occurred");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (students_id) {
      fetchStudents(students_id);
    }
  }, [students_id]);

  const fetchStudents = async (students_id) => {
    const id = students_id.student_id;
    get_all_registered_students()
      .then((response) => {
        const matches = response.data.filter((item) => item.student_id === id);
        if (matches.length > 0) {
          const student = matches[0];
          setStudentId(student.student_id || "");
          setFirstName(student.first_name || "");
          setLastName(student.last_name || "");
          setEmailId(student.email || "");
          setMobileNumber(student.mobile_no || "");
          setGender(student.gender || student.hostel_name || "");
          
          setBuyingBehaviour(student.buying_behaviour || student.father_name || "");
          setPricing(student.pricing || student.mother_name || "");
          setCurrency(student.currency || student.boarding_type || "");
          setPassword(student.password || "");
          
          // ✅ Map to boolean flag returned from backend
          setHasServerImage(student.has_image === true);
        }
      })
      .catch(() => {});
  };

  return (
    <>
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
      <div className="container">
        
        <div className="form-section">
                  {/* ✅ BACK BUTTON */}
          <button 
            onClick={() => history.push("/admin/editmember")}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              backgroundColor: 'transparent',
              border: 'none',
              color: '#6b7280',
              cursor: 'pointer',
              fontSize: '15px',
              fontWeight: '600',
              marginBottom: '20px',
              padding: 0
            }}
          >
            <MdArrowBack size={20} />
            Back to Menu
          </button>
          <h2>Edit Customer Details</h2>

          <div className="form-group">
            <label className="lebcs">Customer ID</label>
            <input className="Asss" type="text" value={student_id} onChange={(e) => setStudentId(e.target.value)} placeholder="Enter ID" disabled />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">First Name</label>
              <input className="Asss" type="text" placeholder="First Name" value={first_name} onChange={(e) => setFirstName(e.target.value)} />
            </div>
            <div className="form-group">
              <label className="lebcs">Last Name</label>
              <input className="Asss" type="text" placeholder="Last Name" value={last_name} onChange={(e) => setLastName(e.target.value)} />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Email</label>
              <input className="Asss" type="email" placeholder="Email Address" value={email} onChange={(e) => setEmailId(e.target.value)} />
            </div>

            <div className="form-group">
              <label className="lebcs">Gender</label>
              <select className="Asss" value={gender} onChange={(e) => setGender(e.target.value)}>
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Contact Number</label>
              <input className="Asss" type="tel" placeholder="Contact Number" value={mobile_no} onChange={(e) => setMobileNumber(e.target.value)} />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Buying Behaviour</label>
              <select className="Asss" value={buyingBehaviour} onChange={(e) => setBuyingBehaviour(e.target.value)}>
                <option value="" disabled>Select Behaviour</option>
                {buyingBehaviours.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label className="lebcs">Pricing</label>
              <select className="Asss" value={pricing} onChange={(e) => setPricing(e.target.value)}>
                <option value="" disabled>Select Pricing Range</option>
                {pricingTiers.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Currency</label>
              <select className="Asss" value={currency} onChange={(e) => setCurrency(e.target.value)}>
                <option value="" disabled>Select Currency</option>
                {currencies.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </div>
          </div>

          <div style={{ marginTop: '30px' }}>
            <button className="upload-btn" onClick={handleSubmit} disabled={loading} style={{ width: '100%', padding: '12px', fontSize: '16px' }}>
              {loading ? "Updating..." : "Update Customer"}
            </button>
          </div>
        </div>

        <div className="camera-section">
          <h2>Live Camera</h2>
          
          {/* ✅ FIXED: Construct URL pointing directly to API instead of Base64 blob */}
          {!hidePreview && hasServerImage && (
            <img
              src={`${REACT_APP_API_URL}/${API_ROUTES.get_student_image(student_id)}`}
              alt="Current Saved Face"
              style={{ width: "150px", border: "2px solid #00bcd4", borderRadius: "50%", marginBottom: "15px", objectFit: "cover", height: "150px" }}
              onError={(e) => e.target.style.display = 'none'}
            />
          )}

          <AutoFaceIdCamera onImageCapture={handleImageCapture} />

          <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginTop: "15px" }}>
            <label style={{ 
                color: '#fff', 
                backgroundColor: '#00bcd4',
                padding: '10px 20px',
                borderRadius: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontWeight: 'bold',
                boxShadow: '0 4px 10px rgba(0, 188, 212, 0.3)',
                marginBottom: '15px'
              }} 
              htmlFor="student_images"
            >
              Upload Image(s)
              <MdUpload size={20} />
              <input className="Asss" id="student_images" accept=".png, .jpeg, .jpg" style={{ display: "none" }} type="file" multiple onChange={handleMultipleImageChange} />
            </label>

            {allImages.length > 0 && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center", width: "100%" }}>
                {allImages.map((img, index) => {
                  const isFile = img instanceof File || img instanceof Blob;
                  const imgSrc = isFile ? URL.createObjectURL(img) : img;

                  return (
                    <div key={index} style={{ position: "relative", width: "70px", height: "70px" }}>
                      <img src={imgSrc} alt={`captured-face-${index}`} style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px", border: "2px solid #00bcd4" }} />
                      <button
                        type="button"
                        onClick={() => removeImage(index)}
                        style={{
                          position: "absolute", top: "-6px", right: "-6px", background: "#ff4444", color: "white", border: "none",
                          borderRadius: "50%", width: "22px", height: "22px", cursor: "pointer", display: "flex", alignItems: "center",
                          justifyContent: "center", fontSize: "12px", boxShadow: "0 2px 5px rgba(0,0,0,0.4)"
                        }}
                      >
                        <MdDelete size={14} />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddStudentDetailsE;
